import { BadgeType } from '@/components/view/atoms/badge/Badge'

// ファイル取込（アップロードのログ）の状態・取込元の表示

export const uploadStatusBadgeType = (status: string): BadgeType => {
  switch (status) {
    case 'completed':
      return BadgeType.SUCCESS
    case 'processing':
      return BadgeType.EMPHASIS
    case 'pending':
      return BadgeType.CAUTION
    case 'failed':
      return BadgeType.CRITICAL
    default:
      return BadgeType.DEFAULT
  }
}

export const uploadStatusLabel = (status: string): string => {
  switch (status) {
    case 'completed':
      return '完了'
    case 'processing':
      return '処理中'
    case 'pending':
      return '待機中'
    case 'failed':
      return '失敗'
    // 同じサイト・同じ種別の新しいファイルが届いていたため、取り込まずに飛ばした（skip-superseded-uploads）
    case 'superseded':
      return '取込不要'
    default:
      return status
  }
}

export const UPLOAD_STATUS_CHOICES = [
  { name: '全ステータス', value: '' },
  { name: '待機中', value: 'pending' },
  { name: '処理中', value: 'processing' },
  { name: '完了', value: 'completed' },
  { name: '失敗', value: 'failed' },
  { name: '取込不要', value: 'superseded' }
]

export const uploadSourceBadgeType = (source: string): BadgeType => {
  switch (source) {
    case 'ftp':
      return BadgeType.EMPHASIS
    case 'manual':
      return BadgeType.CAUTION
    case 'http':
      return BadgeType.SUCCESS
    default:
      return BadgeType.DEFAULT
  }
}

const UPLOAD_SOURCE_LABELS: Record<string, string> = {
  http: 'API',
  ftp: 'FTP',
  manual: '手動'
}

export const uploadSourceLabel = (source: string): string => UPLOAD_SOURCE_LABELS[source] || source

// リトライできるのは、取込が終わった（完了・失敗）ログだけ。
// 取込不要のログは、より新しいファイルがあるため、リトライしても取り込まない
export const isRetryableUpload = (status: string): boolean =>
  status === 'failed' || status === 'completed'
